export default __webpack_public_path__ + "static/media/VCR_OSD_MONO_1.001.10cf96d5.ttf";